/* eslint-disable no-shadow */
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: {
      borders: {
        main: {
          color: string;
        };
      };
      primary: {
        main: {
          color: string;
          contrastText: string;
        };
      };
      secondary: {
        main: {
          color: string;
          contrastText: string;
        };
      };
      error: {
        main: {
          color: string;
          contrastText: string;
        };
        secondary: {
          color: string;
          contrastText: string;
        };
      };
    };
    fontFamily: {
      primary: string;
    };
  }
}

export const theme: DefaultTheme = {
  colors: {
    borders: {
      main: {
        color: '#D7D7D7',
      },
    },
    primary: {
      main: {
        color: '#005cde',
        contrastText: '#FFFFFF',
      },
    },
    secondary: {
      main: {
        color: '#969CB3',
        contrastText: '#FFFFFF',
      },
    },
    error: {
      main: {
        color: '#E40D39',
        contrastText: '#FFFFFF',
      },
      secondary: {
        color: '#D10000',
        contrastText: '#FFFFFF',
      },
    },
  },
  fontFamily: {
    primary: "'Inter', sans-serif",
  },
};
